import React, { useEffect, useRef, useState } from "react"
import { useParams } from "react-router-dom"
import searchFilter from "../../../../state/searchFilter";
import Esign from "../Esign";
import useToggle from "../../../../hooks/toggle";
import { selecteddocumentesign } from "../ReviewDocs";
import { useReactToPrint } from "react-to-print";
import { useSelector } from "react-redux";
import { getexternaldocuments, getSavedOfferDetails, SaveAffiliatedBusinessArrangement } from "../../../../api/transaction";
import { CSpinner } from "@coreui/react";
import { setAgentSubsource } from "../../../../state/actions";


const ReqAffiliatedBusinessArrangement = () => {
  const params: { id: any, user: string } = useParams()
  const { id, user } = params
  const [loader,setloading] = useState(false)
  const [affiliatebus, SetAffiliateBus] = useState({

    offer_id: id,
    date: null,
    property_address: "",
    buyer1_signature: null,
    buyer1_signature_date: "",
    buyer2_signature: null,
    buyer2_signature_date: "",
    seller1_signature: null,
    seller1_signature_date: "",
    seller2_signature: null,
    seller2_signature_date: ""
  })

  const componentRef = useRef();
  const [canvasmodal, setCanvasModal] = useToggle(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
    offerid: "",
    document_name: "",
    image_base64: "",
    sign_role: 1
  })
  const [offerdetails, setOfferDetails]: any = useState({});
  const printf = () => {
    handlePrint()
  };
  // @ts-ignore
  const val = useSelector((state) => state?.new?.signset)
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(()=>{
    if(val){
        if(user == "seller"){
          SetAffiliateBus({ ...affiliatebus, seller1_signature: val })
        }
        if(user == "client"){
          SetAffiliateBus({ ...affiliatebus, buyer1_signature: val })
        }
    }
    },[val])

  const send = async () => {
setloading(true)
    if (user === "seller") {

      if (affiliatebus?.seller1_signature) {
        const res = await SaveAffiliatedBusinessArrangement(affiliatebus)
        if(res?.status == "success"){
          alert("Submitted Successfully")
      }
      else{
          alert("Something went wrong")
      }
      }

    } else if (user === "client") {
    
      if (affiliatebus?.buyer1_signature) {
        const res = await SaveAffiliatedBusinessArrangement(affiliatebus)
        if(res?.status == "success"){
          alert("Submitted Successfully")
      }
      else{
          alert("Something went wrong")
      }
      }
    }
    setloading(false)
  }

  useEffect(()=>{
    (async function(){
        let offerdetails = await getSavedOfferDetails(id)
        setOfferDetails(offerdetails[0])
      const res =await getexternaldocuments(id,"affiliatedbusinessarrangement") 
      SetAffiliateBus({...affiliatebus,
        date: res?.data?.date,
        property_address: res?.data?.property_address,
        buyer1_signature: res?.data?.buyer1_signature,
        buyer1_signature_date: res?.data?.buyer1_signature_date,
        buyer2_signature: res?.data?.buyer2_signature,
        buyer2_signature_date: res?.data?.buyer2_signature_date,
        seller1_signature: res?.data?.seller1_signature,
        seller1_signature_date: res?.data?.seller1_signature_date,
        seller2_signature: res?.data?.seller2_signature,
        seller2_signature_date: res?.data?.seller2_signature_date
      })
    })()
  },[])

  return (
    <>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600&display=swap"
        rel="stylesheet"
      />
      <style
        dangerouslySetInnerHTML={{
          __html:
            '\n        * {\n            font-family: "Poppins", sans-serif;\n        }\n    '
        }}
      />
      <title>Document</title>
      <div ref={componentRef}>
      <section style={{ pageBreakAfter: "always" }}>
  <table
    style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 20 }}
  >
    <tbody>
      <tr>
        <td>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td style={{ width: "90%" }}>
                  <img
                    style={{ width: 250 }}
                    src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                  />
                </td>
                <td>
                  <img
                    style={{ width: 40, marginRight: 15 }}
                    src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                    alt=""
                  />
                  <img
                    style={{ width: 50 }}
                    src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                    alt=""
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          <span style={{ fontSize: 20, fontWeight: 700 }}>
            Affiliated Business Arrangement Disclosure
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          Date:
          <input
            type="date"
            value={affiliatebus?.date}
            onChange={(e)=>SetAffiliateBus({...affiliatebus,date:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "95%"
            }}
          />
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          Property Address:
          <input
            type="text"
            value={offerdetails?.propertyAddress}
            // onChange={(e)=>SetAffiliateBus({...affiliatebus,date:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "85%"
            }}
          />
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          This is to give you notice that Milford Real Estate, has a business
          relationship with the following service providers of which are wholly
          or partially owned by Milford Real Estate or its owners. Because of
          this relationship, this referral may provide Milford Real Estate or
          its owners with financial or other benefit
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          Set forth below is the estimated charge or range of charges for the
          closing services listed. You are NOT required to use the listed
          provider as a condition for purchase/sale of the subject property
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          THERE ARE FREQUENTLY OTHER CLOSING SERVICE PROVIDERS AVAILABLE WITH
          SIMILAR SERVICES. YOU ARE FREE TO SHOP AROUND TO DETERMINE THAT YOU
          ARE RECEIVING THE BEST SERVICES AND THE BEST RATE FOR THE SERVICES
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td style={{ border: "1px solid #3b0083", width: "33%" }}>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ border: "1px solid #3b0083" }}>
                          <table style={{ width: "100%", borderSpacing: 0 }}>
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    background: "#272727",
                                    color: "#bb8af7",
                                    border: "1px solid #ab94e0",
                                    padding: 10,
                                    fontWeight: 600
                                  }}
                                >
                                  Provider:
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: 600, padding: 10 }}>
                          Milford Closing
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: 10 }}>
                          Escrow Closer:
                          <br />
                          Jesse Diamond
                          <br />
                          orders@milfordclosing.com
                          <br />
                          402.492.2417
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            borderBottom: "1px solid #3b0083",
                            borderTop: "1px solid #3b0083",
                            padding: 10
                          }}
                        >
                          Milford Marketing
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: 10 }}>Milford Select</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td style={{ border: "1px solid #3b0083", width: "33%" }}>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ border: "1px solid #3b0083" }}>
                          <table style={{ width: "100%", borderSpacing: 0 }}>
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    background: "#272727",
                                    color: "#bb8af7",
                                    border: "1px solid #ab94e0",
                                    padding: 10,
                                    fontWeight: 600
                                  }}
                                >
                                  Settlement Service:
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: 10 }}>Lender (Loan) Closing</td>
                      </tr>
                      <tr>
                        <td style={{ padding: 10, height: 100 }}></td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            borderBottom: "1px solid #3b0083",
                            borderTop: "1px solid #3b0083",
                            padding: 10
                          }}
                        >
                          Marketing
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: 10 }}>Real Estate Services</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td style={{ border: "1px solid #3b0083", width: "33%" }}>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ border: "1px solid #3b0083" }}>
                          <table style={{ width: "100%", borderSpacing: 0 }}>
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    background: "#272727",
                                    color: "#bb8af7",
                                    border: "1px solid #ab94e0",
                                    padding: 10,
                                    fontWeight: 600
                                  }}
                                >
                                  Charges:
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: 10 }}>
                          $325-$1,500
                          <br />
                          (Based on transaction type)
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: 10, height: 75 }}></td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            borderBottom: "1px solid #3b0083",
                            borderTop: "1px solid #3b0083",
                            padding: 10
                          }}
                        >
                          Price Varies
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: 10 }}>Price Varies</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          Further, notice is hereby given that Milford Closing is not licensed
          to issue title insurance policies and unless directed otherwise,
          refers all requests for title insurance to{" "}
          <span style={{ fontWeight: 700 }}>
            {" "}
            Nebraska Title Company, 14680 W. Dodge Road, Suite 1, Omaha, NE
            68154, 402-861-9220.
          </span>{" "}
          Milford Closing will NOT receive financial or other benefit from the
          referral of business to Nebraska Title Company.
        </td>
      </tr>
      <tr>
        <td style={{ fontWeight: 700, color: "#3b0083", padding: "10px 0px" }}>
          Acknowledgment
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          I/We have read this disclosure form, and understand that the referring
          realtor names above is referring me/us to purchase the above described
          closing service(s) and may receive a financial or other benefit as a
          result of this referral.
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          <table style={{ width: "100%" , tableLayout: "fixed"}}>
            <tbody>
              <tr>
                <td>
                <img src={user === "client" ? (val || affiliatebus?.buyer1_signature) : affiliatebus?.buyer1_signature} alt="" />
                
                  <br />
                  Buyer
                </td>
                <td>
                  <input type="date" 
                  value={affiliatebus?.buyer1_signature_date ? affiliatebus?.buyer1_signature_date :  (user === "client" && val || affiliatebus?.buyer1_signature) ? new Date().toISOString().split('T')[0] : ""}
                  />
                  <br />
                  date
                </td>
                <td>
                <img src={user === "seller" ? (val || affiliatebus?.seller1_signature) : affiliatebus?.seller1_signature} alt="" />
                  <br />
                  Seller
                </td>
                <td>
                <input type="date" 
                value={affiliatebus?.seller1_signature_date ? affiliatebus?.seller1_signature_date : (user === "seller" && val || affiliatebus?.seller1_signature) ? new Date().toISOString().split('T')[0] : ""} 
                onChange={(e)=>SetAffiliateBus({...affiliatebus,seller1_signature_date:e.target.value})}/>
                  <br />
                  date
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          <table style={{ width: "100%", tableLayout: "fixed" }}>
            <tbody>
              <tr>
                <td>
                <input
                    type="text"
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid black",
                      width: 250
                    }}
                  />
                  <br />
                  Buyer
                </td>
                <td>
                <input type="date" />
                 
                  <br />
                  date
                </td>
                <td>
                <input
                    type="text"
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid black",
                      width: 250
                    }}
                  />
                  <br />
                  Seller
                </td>
                <td>
                <input type="date" />
                  <br />
                  date
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</section>

        {/* <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <title>AffiliatedBusArrang_Wire</title>
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              "\n        * {\n            margin: 0;\n            padding: 0;\n            text-indent: 0;\n        }\n\n        h1 {\n            color: #231F20;\n            font-family: Calibri, sans-serif;\n            font-style: normal;\n            font-weight: bold;\n            text-decoration: none;\n            font-size: 14.5pt;\n        }\n\n        p {\n            color: #231F20;\n            font-family: Calibri, sans-serif;\n            font-style: normal;\n            font-weight: normal;\n            text-decoration: none;\n            font-size: 9pt;\n            margin: 0pt;\n        }\n\n        .s2 {\n            color: #AB93DF;\n            font-family: Calibri, sans-serif;\n            font-style: normal;\n            font-weight: bold;\n            text-decoration: none;\n            font-size: 9pt;\n        }\n\n        .s3 {\n            color: #231F20;\n            font-family: Calibri, sans-serif;\n            font-style: normal;\n            font-weight: bold;\n            text-decoration: none;\n            font-size: 9pt;\n        }\n\n        .s4 {\n            color: #231F20;\n            font-family: Calibri, sans-serif;\n            font-style: normal;\n            font-weight: normal;\n            text-decoration: none;\n            font-size: 9pt;\n        }\n\n        .s5 {\n            color: #231F20;\n            font-family: Calibri, sans-serif;\n            font-style: normal;\n            font-weight: normal;\n            text-decoration: none;\n            font-size: 9pt;\n        }\n\n        .s6 {\n            color: #231F20;\n            font-family: Calibri, sans-serif;\n            font-style: normal;\n            font-weight: normal;\n            text-decoration: none;\n            font-size: 10pt;\n        }\n\n        .s7 {\n            color: #3A0083;\n            font-family: Calibri, sans-serif;\n            font-style: normal;\n            font-weight: bold;\n            text-decoration: none;\n            font-size: 9pt;\n        }\n\n        .s9 {\n            color: #231F20;\n            font-family: Calibri, sans-serif;\n            font-style: normal;\n            font-weight: bold;\n            text-decoration: none;\n            font-size: 12.5pt;\n        }\n\n        .s10 {\n            color: #3A0083;\n            font-family: Calibri, sans-serif;\n            font-style: normal;\n            font-weight: bold;\n            text-decoration: none;\n            font-size: 9pt;\n        }\n\n        table,\n        tbody {\n            vertical-align: top;\n            overflow: visible;\n        }\n\n\n        \ncanvas {  \n  background-color: #fff;\n  border-radius: 15px;\n  border: 5px solid black; \n}\n\n#canvas-wrap {\n  position: relative;\n \n}\n\n #download, #clear {\n        position: relative;\n        top: 0;\n        left: 170px;\n        padding: 10px;\n        background-color: #57c4e5;\n        border: 3px solid black;\n        color: black;\n        display: block-inline;\n        margin-top: 5px;\n        margin-right:5px;\n        transition: .3s;\n      }\n\n#download:hover, #clear:hover {\n  background-color: transparent;\n}\n\n#text {\n  position:relative;\n  font-weight: bold;\n  left: 190px;\n}\n    "
          }}
        />
        <h1
          style={{
            paddingTop: "4pt",
            paddingLeft: "6pt",
            textIndent: "0pt",
            textAlign: "left"
          }}
        >
          Affiliated Business Arrangement Disclosure
        </h1>
        <p style={{ paddingTop: "8pt", textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          style={{
            paddingLeft: "6pt",
            textIndent: "0pt",
            lineHeight: "191%",
            textAlign: "left"
          }}
        >
          Date:
          <input type="date" value={affiliatebus?.date} onChange={(e) => { SetAffiliateBus({ ...affiliatebus, date: e?.target?.value }) }} name="" id="" />{" "}
          Property Address:
          <input type="text" value={offerdetails?.propertyAddress} />
        </p>
        <p style={{ paddingTop: "10pt", textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          style={{
            paddingLeft: "6pt",
            textIndent: "0pt",
            lineHeight: "109%",
            textAlign: "left"
          }}
        >
          This is to give you notice that Milford Real Estate, has a business
          relationship with the following service providers of which are wholly or
          partially owned by Milford Real Estate or its owners. Because of this
          relationship, this referral may provide Milford Real Estate or its owners
          with financial or other benefit.
        </p>
        <p
          style={{
            paddingTop: "9pt",
            paddingLeft: "6pt",
            textIndent: "0pt",
            lineHeight: "109%",
            textAlign: "left"
          }}
        >
          Set forth below is the estimated charge or range of charges for the closing
          services listed. You are NOT required to use the listed provider as a
          condition for purchase/sale of the subject property.
        </p>
        <p
          style={{
            paddingTop: "9pt",
            paddingLeft: "6pt",
            textIndent: "0pt",
            lineHeight: "109%",
            textAlign: "left"
          }}
        >
          THERE ARE FREQUENTLY OTHER CLOSING SERVICE PROVIDERS AVAILABLE WITH SIMILAR
          SERVICES. YOU ARE FREE TO SHOP AROUND TO DETERMINE THAT YOU ARE RECEIVING
          THE BEST SERVICES AND THE BEST RATE FOR THE SERVICES.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <table
          style={{ borderCollapse: "collapse", marginLeft: "6.25pt" }}
          cellSpacing={0}
        >
          <tbody>
            <tr style={{ height: "26pt" }}>
              <td
                style={{
                  width: "180pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderTopColor: "#3A0083",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderLeftColor: "#3A0083",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderBottomColor: "#3A0083",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt",
                  borderRightColor: "#FFFFFF",
                  backgroundColor: '#1E1D1E'
                }}

              >
                <p
                  className="s2"
                  style={{
                    paddingTop: "7pt",
                    paddingLeft: "9pt",
                    textIndent: "0pt",
                    textAlign: "left"
                  }}
                >
                  Provider:
                </p>
              </td>
              <td
                style={{
                  width: "180pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderTopColor: "#3A0083",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderLeftColor: "#FFFFFF",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderBottomColor: "#3A0083",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt",
                  borderRightColor: "#FFFFFF",
                  backgroundColor: '#1E1D1E'
                }}

              >
                <p
                  className="s2"
                  style={{
                    paddingTop: "7pt",
                    paddingLeft: "9pt",
                    textIndent: "0pt",
                    textAlign: "left"
                  }}
                >
                  Settlement Service:
                </p>
              </td>
              <td
                style={{
                  width: "180pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderTopColor: "#3A0083",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderLeftColor: "#FFFFFF",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderBottomColor: "#3A0083",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt",
                  borderRightColor: "#3A0083",
                  backgroundColor: '#1E1D1E'
                }}

              >
                <p
                  className="s2"
                  style={{
                    paddingTop: "7pt",
                    paddingLeft: "9pt",
                    textIndent: "0pt",
                    textAlign: "left"
                  }}
                >
                  Charges:
                </p>
              </td>
            </tr>
            <tr style={{ height: "87pt" }}>
              <td
                style={{
                  width: "180pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderTopColor: "#3A0083",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderLeftColor: "#3A0083",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderBottomColor: "#472885",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt",
                  borderRightColor: "#472885"
                }}
              >
                <p
                  className="s3"
                  style={{
                    paddingTop: "9pt",
                    paddingLeft: "9pt",
                    textIndent: "0pt",
                    textAlign: "left"
                  }}
                >
                  Milford Closing
                </p>
                <p
                  style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}
                >
                  <br />
                </p>
                <p
                  className="s4"
                  style={{ paddingLeft: "9pt", textIndent: "0pt", textAlign: "left" }}
                >
                  Escrow Closer:
                </p>
                <p
                  className="s4"
                  style={{
                    paddingTop: "1pt",
                    paddingLeft: "8pt",
                    paddingRight: "20pt",
                    textIndent: "0pt",
                    lineHeight: "109%",
                    textAlign: "left"
                  }}
                >
                  <a
                    href="mailto:orders@milfordclosing.com"
                    className="s5"
                    target="_blank"
                  >
                    Jesse Diamond
                  </a>
                  orders@milfordclosing.com 402.492.2417
                </p>
              </td>
              <td
                style={{
                  width: "180pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderTopColor: "#3A0083",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderLeftColor: "#472885",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderBottomColor: "#472885",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt",
                  borderRightColor: "#472885"
                }}
              >
                <p
                  className="s4"
                  style={{
                    paddingTop: "9pt",
                    paddingLeft: "9pt",
                    textIndent: "0pt",
                    textAlign: "left"
                  }}
                >
                  Lender (Loan) Closing
                </p>
              </td>
              <td
                style={{
                  width: "180pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderTopColor: "#3A0083",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderLeftColor: "#472885",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderBottomColor: "#472885",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt",
                  borderRightColor: "#3A0083"
                }}
              >
                <p
                  className="s4"
                  style={{
                    paddingTop: "9pt",
                    paddingLeft: "9pt",
                    textIndent: "0pt",
                    textAlign: "left"
                  }}
                >
                  $325-$1,500
                </p>
                <p
                  className="s4"
                  style={{
                    paddingTop: "1pt",
                    paddingLeft: "9pt",
                    textIndent: "0pt",
                    textAlign: "left"
                  }}
                >
                  (Based on transaction type)
                </p>
              </td>
            </tr>
            <tr style={{ height: "27pt" }}>
              <td
                style={{
                  width: "180pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderTopColor: "#472885",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderLeftColor: "#3A0083",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderBottomColor: "#3A0083",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt",
                  borderRightColor: "#472885"
                }}
              >
                <p
                  className="s6"
                  style={{
                    paddingTop: "6pt",
                    paddingLeft: "9pt",
                    textIndent: "0pt",
                    textAlign: "left"
                  }}
                >
                  Milford Marketing
                </p>
              </td>
              <td
                style={{
                  width: "180pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderTopColor: "#472885",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderLeftColor: "#472885",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderBottomColor: "#3A0083",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt",
                  borderRightColor: "#472885"
                }}
              >
                <p
                  className="s4"
                  style={{
                    paddingTop: "9pt",
                    paddingLeft: "9pt",
                    textIndent: "0pt",
                    textAlign: "left"
                  }}
                >
                  Marketing
                </p>
              </td>
              <td
                style={{
                  width: "180pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderTopColor: "#472885",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderLeftColor: "#472885",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderBottomColor: "#3A0083",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt",
                  borderRightColor: "#3A0083"
                }}
              >
                <p
                  className="s4"
                  style={{
                    paddingTop: "9pt",
                    paddingLeft: "9pt",
                    textIndent: "0pt",
                    textAlign: "left"
                  }}
                >
                  Price Varies
                </p>
              </td>
            </tr>
            <tr style={{ height: "27pt" }}>
              <td
                style={{
                  width: "180pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderTopColor: "#3A0083",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderLeftColor: "#3A0083",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderBottomColor: "#3A0083",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt",
                  borderRightColor: "#472885"
                }}
              >
                <p
                  className="s6"
                  style={{
                    paddingTop: "6pt",
                    paddingLeft: "9pt",
                    textIndent: "0pt",
                    textAlign: "left"
                  }}
                >
                  Milford Select
                </p>
              </td>
              <td
                style={{
                  width: "180pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderTopColor: "#3A0083",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderLeftColor: "#472885",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderBottomColor: "#3A0083",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt",
                  borderRightColor: "#472885"
                }}
              >
                <p
                  className="s4"
                  style={{
                    paddingTop: "9pt",
                    paddingLeft: "9pt",
                    textIndent: "0pt",
                    textAlign: "left"
                  }}
                >
                  Real Estate Services
                </p>
              </td>
              <td
                style={{
                  width: "180pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderTopColor: "#3A0083",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderLeftColor: "#472885",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderBottomColor: "#3A0083",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt",
                  borderRightColor: "#3A0083"
                }}
              >
                <p
                  className="s4"
                  style={{
                    paddingTop: "9pt",
                    paddingLeft: "9pt",
                    textIndent: "0pt",
                    textAlign: "left"
                  }}
                >
                  Price Varies
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p style={{ paddingTop: "10pt", textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          style={{
            paddingLeft: "5pt",
            textIndent: "0pt",
            lineHeight: "109%",
            textAlign: "left"
          }}
        >
          Further, notice is hereby given that Milford Closing is not licensed to
          issue title insurance policies and unless directed otherwise, refers all
          requests for title insurance to{" "}
          <b>
            Nebraska Title Company, 14680 W. Dodge Road, Suite 1, Omaha, NE 68154,
            402-861-9220
          </b>
          . Milford Closing will NOT receive financial or other benefit from the
          referral of business to Nebraska Title Company.
        </p>
        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          className="s7"
          style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}
        >
          Acknowledgment
        </p>
        <p
          style={{
            paddingTop: "10pt",
            paddingLeft: "6pt",
            textIndent: "0pt",
            lineHeight: "109%",
            textAlign: "left"
          }}
        >
          I/We have read this disclosure form, and understand that the referring
          realtor names above is referring me/us to purchase the above described
          closing service(s) and may receive a financial or other benefit as a result
          of this referral.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <table
          style={{ borderCollapse: "collapse", marginLeft: "6pt" }}
          cellSpacing={0}
        >
          <tbody>
            <tr style={{ height: "15pt" }}>
              <td>
                Buyer:
                <img src={user === "client" ? (val || affiliatebus?.buyer1_signature) : affiliatebus?.buyer1_signature} alt="" />

              </td>
              <td>Date:
                <input type="date" value={affiliatebus?.buyer1_signature_date} onChange={(e) => { SetAffiliateBus({ ...affiliatebus, buyer1_signature_date: e?.target?.value }) }} name="" id="" />

              </td>
              <td>Seller:
                <img src={user === "seller" ? (val || affiliatebus?.seller1_signature) : affiliatebus?.seller1_signature} alt="" />
              </td>
              <td>Date:
                <input type="date" value={affiliatebus?.seller1_signature_date} onChange={(e) => { SetAffiliateBus({ ...affiliatebus, seller1_signature_date: e?.target?.value }) }} name="" id="" />

              </td>
            </tr>
            <tr style={{ height: "15pt" }}>
              <td>
                Buyer:
                <img alt="" />
              </td>
              <td>Date:
                <input type="date" value={affiliatebus?.buyer2_signature_date} onChange={(e) => { SetAffiliateBus({ ...affiliatebus, buyer2_signature_date: e?.target?.value }) }} name="" id="" />

              </td>
              <td>Seller:
                <img alt="" />
              </td>
              <td>Date:
                <input type="date" value={affiliatebus?.seller2_signature_date} onChange={(e) => { SetAffiliateBus({ ...affiliatebus, seller2_signature_date: e?.target?.value }) }} name="" id="" />

              </td>
            </tr>
          </tbody>
        </table>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        {/* <table
    style={{ borderCollapse: "collapse", marginLeft: "6pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "15pt" }}>
        <td
          style={{
            width: "257pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#472885"
          }}
        >
          <p
            className="s4"
            style={{
              paddingTop: "3pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            Buyer Date
          </p>
        </td>
        <td style={{ width: "13pt" }}>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "257pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#472885"
          }}
        >
          <p
            className="s4"
            style={{
              paddingTop: "3pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            Seller Date
          </p>
        </td>
      </tr>
    </tbody>
  </table> */}
        {/* <h1
    style={{
      paddingTop: "4pt",
      paddingLeft: "6pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Wire Fraud Notice Addendum
  </h1>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "6pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "432pt" }}>
        <td
          style={{
            width: "485pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#472885"
          }}
          colSpan={2}
        >
          <p
            className="s4"
            style={{
              paddingRight: "157pt",
              textIndent: "0pt",
              lineHeight: "197%",
              textAlign: "left"
            }}
          >
            This addendum is in addition to and becomes part of the Purchase
            Agreement dated
            <u>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </u>{" "}
            on the property known as
            <u>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </u>
          </p>
          <p
            className="s9"
            style={{
              paddingTop: "9pt",
              paddingRight: "157pt",
              textIndent: "0pt",
              lineHeight: "106%",
              textAlign: "left"
            }}
          >
            Notice to Buyer and Seller Regarding Wire Fraud and Suspicious
            Communications:
          </p>
          <p
            style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}
          >
            <br />
          </p>
          <p
            className="s4"
            style={{
              paddingRight: "3pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "left"
            }}
          >
            Please be aware that the Escrow Company under the attached Agreement
            may require a wire transfer of funds at Closing. Buyer and Seller
            should take care to provide wire transfer information only to a
            proper agent of the Escrow Company. Funds should only be wired to
            the Escrow Company using account information provided by verified
            agents of the Escrow Company.
          </p>
          <p
            className="s4"
            style={{
              paddingTop: "8pt",
              paddingRight: "3pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "left"
            }}
          >
            Recently, criminals have been found attempting to impersonate escrow
            companies and real estate agents in wire fraud schemes. Unauthorized
            individuals have been caught providing fraudulent wire transfer
            information to parties in real estate transactions. This could
            include a criminal contacting Buyer or Seller, directly or
            indirectly, in an attempt to steal funds that rightfully belong to
            the parties.{" "}
            <b>
              These sophisticated criminals may try to hack into your email
              account or the email of other persons involved in your transaction
              and direct you to send a wire to the hacker’s account. THEY CAN
              EVEN SEND EMAILS THAT APPEAR TO BE FROM YOUR AGENT, YOUR CLOSER OR
              ANOTHER TRUSTED SOURCE!
            </b>
          </p>
          <p
            className="s3"
            style={{ paddingTop: "8pt", textIndent: "0pt", textAlign: "left" }}
          >
            MILFORD REAL ESTATE WILL NEVER ASK YOU TO WIRE MONEY VIA EMAIL,
            EVER!
          </p>
          <p
            className="s4"
            style={{
              paddingTop: "10pt",
              paddingRight: "3pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "left"
            }}
          >
            In the event any party believes an unauthorized request has been
            made for bank account information or funds, the Escrow Company
            should be contacted immediately. The request should be verified
            immediately in person or by telephone using a telephone number that
            is known to be valid. Parties should be especially skeptical of last
            minute changes or requests coming from unknown representatives.{" "}
            <b>
              DO NOT USE A PHONE NUMBER OR OTHER CONTACT INFORMATION FROM AN
              EMAIL. Use a business number from another source (such as the
              closing company’s website) to make sure you are actually talking
              to your closer and not someone intent on stealing your money.
            </b>
          </p>
          <p
            className="s4"
            style={{
              paddingTop: "8pt",
              paddingRight: "10pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "left"
            }}
          >
            In the event funds are transferred to a fraudulent account, there
            may be no way to recover these funds from the criminals involved.
            For this reason, it is extremely important that the Buyer and Seller
            are vigilant and only provide wire transfer information to proper
            representatives of the Escrow Company.
          </p>
          <p
            className="s10"
            style={{ paddingTop: "8pt", textIndent: "0pt", textAlign: "left" }}
          >
            PLEASE CONTACT THE ESCROW COMPANY DIRECTLY IF YOU HAVE ANY
            QUESTIONS.
          </p>
        </td>
      </tr>
      <tr style={{ height: "45pt" }}>
        <td
          style={{
            width: "209pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#472885",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#472885"
          }}
        >
          <p
            className="s4"
            style={{ paddingTop: "4pt", textIndent: "0pt", textAlign: "left" }}
          >
            Buyer Date
          </p>
        </td>
        <td
          style={{
            width: "276pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#472885",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#472885"
          }}
        >
          <p
            className="s4"
            style={{
              paddingTop: "4pt",
              paddingLeft: "34pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            Seller Date
          </p>
        </td>
      </tr>
      <tr style={{ height: "45pt" }}>
        <td
          style={{
            width: "209pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#472885",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#472885"
          }}
        >
          <p
            className="s4"
            style={{ paddingTop: "4pt", textIndent: "0pt", textAlign: "left" }}
          >
            Buyer Date
          </p>
        </td>
        <td
          style={{
            width: "276pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#472885",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#472885"
          }}
        >
          <p
            className="s4"
            style={{
              paddingTop: "4pt",
              paddingLeft: "34pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            Seller Date
          </p>
        </td>
      </tr>
    </tbody>
  </table> */} 
      </div>

      <React.Fragment>
        <div className="d-flex align-items-center justify-content-end mb-2 mr-2">
          <button onClick={send} className="btn primaryColorBtn">Submit
          {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
          </button>
          <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
          <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button>
        </div>
      </React.Fragment>

      <Esign
        canvasmodal={canvasmodal}
        setCanvasModal={setCanvasModal}
        htmlContent={htmlContent}
        setHtmlContent={setHtmlContent}
        selecteddocumentesign={selecteddocumentesign}
        setselectedDocumentEsign={setselectedDocumentEsign}
        type={"seller"}
      ></Esign>
    </>


  )
}

export default ReqAffiliatedBusinessArrangement